import axios from "axios";

const api = axios.create({
  // baseURL: process.env.API_URL || 'http://localhost:5452',
  baseURL: process.env.API_URL || 'http://node.seculosengenharia.com.br:3000',
});

export default api;